import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/riwayatPangkatService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "")
        : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    source
    historyTable = 'historyRiwayatPangkatTableActive'
    defaultOrder = 'rank_history_tmt_date'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            uploadSKUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            approveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            uuid: this.peg_uuid
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "rank_name",
            text: "Pangkat",
            className: "rank_name",
            sortable: true,
        },

        {
            key: "rank_history_decree_number",
            text: "Nomor SK",
            className: "rank_history_decree_number",
            sortable: true,
        },
        {
            key: "rank_group_room",
            text: "Golongan",
            className: "rank_group_room",
            sortable: true,
            cell: (record) => {
                return (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: record.rank_group_room,
                        }}
                    />
                );
            },
        },
        {
            key: "rank_history_tmt_date",
            text: "TMT",
            className: "rank_history_tmt_date",
            sortable: true,
            width: '120',
            cell: record => {
                return this.dateParse(record.rank_history_tmt_date);
            }
        },
        {
            key: "rank_history_year_period",
            text: "Masa Kerja",
            className: "rank_history_year_period",
            sortable: true,
            cell: (record) => {
                return (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: record.rank_history_year_period+' Tahun<br>'+record.rank_history_month_period+' Bulan',
                        }}
                    />
                );
            },
        },
        // {
        //     key: "rank_history_decree_date",
        //     text: "Tanggal SK",
        //     className: "rank_history_decree_date",
        //     sortable: true,
        //     width: '120',
        //     cell: record => {
        //         return this.dateParse(record.rank_history_decree_date)
        //     }
        // },
        {
            key: "rank_history_status_name",
            text: "Status",
            className: "rank_history_status_name",
            sortable: true,
            width: '100',
            cell: record => {
                var status = record.rank_history_status
                var status_name = record.rank_history_status_name
                return (
                    <span>
                        {parseInt(status) == 1 ?
                            <label className="badge rounded-pill bg-soft-success font-size-12" >{status_name}</label> :
                            <label className="badge rounded-pill bg-soft-warning font-size-12" >{status_name}</label>}
                    </span>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 170,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.rank_history_id
                var status = record.rank_history_status
                var loguuid = record.rank_history_log_uuidS
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.rank_history_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId]: !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat Detail</Tooltip>
                        </span>
                        {(accessRole('update') && status == 1) && this.currentRoleId == 1 ?
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.rank_history_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId]: !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span>
                            : null
                        }
                        {
                            accessRole('approve') &&
                            <span>
                                <button
                                    className="btn btn-info btn-sm"
                                    id={"uploadsk-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            uploadSKUuid: record.rank_history_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-upload"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["uploadsk" + thisId]} target={"uploadsk-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["uploadsk" + thisId]: !this.state["uploadsk" + thisId]
                                        })
                                    }}
                                >Upload SK</Tooltip>
                            </span>
                        }
                        {(accessRole('delete') && status == 1 && this.currentRoleId == 1) ?
                            <span>

                                {/* <span> */}
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.modal_confirm_status = 1
                                        this.modal_confirm_message = "Apakah anda yakin akan menonaktifkan data ini ?"
                                        this.setState({
                                            inactiveUuid: record.rank_history_uuid,
                                            confirm: true
                                        })
                                    }}
                                    style={{
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId]: !this.state["delete" + thisId]
                                        })
                                    }}
                                >Nonaktifkan
                                </Tooltip>
                            </span>
                            : ''
                        }
                        {accessRole('approve') && status == 0 ?
                            <span>
                                <button
                                    className="btn btn-success btn-sm"
                                    id={"approve-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            approveUuid: record.rank_history_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-check"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["approve" + thisId]} target={"approve-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["approve" + thisId]: !this.state["approve" + thisId]
                                        })
                                    }}
                                >Approve</Tooltip>
                            </span>
                            : null
                        }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/home.html?riwayat_pangkat&detail&uuid=" + this.state.detailUuid} />
                    : null}
                {this.state.uploadSKUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/home.html?riwayat_pangkat&upload_sk&uuid=" + this.state.uploadSKUuid} />
                    : null}
                {this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?riwayat_pangkat&update&uuid=" + this.state.updateUuid} />
                    : null}
                {this.state.approveUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?riwayat_pangkat&approve&uuid=" + this.state.approveUuid} />
                    : null}
            </>
        )
    }

}

export default TableActiveComponent